export default __webpack_public_path__ + "static/media/Conor-Halpin---FEA-Winner-2024.dbfe037b.jpg";